var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"mt--6",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"xl":"12","md":"8"}},[_c('VehicleCard')],1),_c('b-col',{staticClass:"mt-4",attrs:{"xl":"12","md":"4"}},[_c('VehicleResume')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }